import React from "react"
import Icon from "components/elements/Icon"
import GuestListIcon from "components/elements/GuestListIcon"
import { EventGroup } from "sharedTypes"

type Props = {
  // When present, render the tag visual from the event group itself (icon
  // and color picked by the user). When absent, render the string-based
  // legacy icon (default segments, confirmation statuses, custom segments).
  eventGroup?: EventGroup
  icon?: string
  iconColor?: string
  // Filter-row size on the Chakra spacing scale. The two surfaces in use
  // (page-header trigger / sidebar EditableFilter) pass 5 / 4 respectively.
  // Numerically equivalent across legacy Icon (`size`) and Chakra Icon
  // (`boxSize`) since both resolve to `size * 0.25rem`.
  size: number
  mr?: number
}

// The legacy Icon "dot" / "circle" glyphs were drawn at a smaller intrinsic
// weight than the rest of the IcoMoon set, so callers historically rendered
// them at size - 1 to compensate. Preserve that.
const DOT_LIKE = new Set(["dot", "circle"])

export const TABULAR_NUMS_SX = { fontVariantNumeric: "tabular-nums" } as const

const FilterIcon = ({
  eventGroup, icon, iconColor, size, mr = 2,
}: Props) => {
  if (eventGroup) {
    return (
      <GuestListIcon
        icon={eventGroup.icon}
        color={eventGroup.color}
        boxSize={size}
        mr={mr}
        flexShrink={0}
      />
    )
  }

  const name = icon || "dot"

  return (
    <Icon
      icon={name}
      size={DOT_LIKE.has(name) ? size - 1 : size}
      mr={mr}
      flexShrink={0}
      color={iconColor}
    />
  )
}

export default FilterIcon
